module.exports = __webpack_public_path__ + "img/牛膝.784815bc.jpg";